import { render } from "./LoyersAPercevoirTable.vue?vue&type=template&id=6381a293"
import script from "./LoyersAPercevoirTable.vue?vue&type=script&lang=js"
export * from "./LoyersAPercevoirTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__